import React from 'react';
import { Award, Shield, MessageCircle, Share2 } from 'lucide-react';

const Hero: React.FC = () => {
  return (
    <section id="inicio" className="hero">
      <div className="container">
        <div className="hero-content">
          <div className="hero-text">
            <div className="hero-promo-badge">
              🚀 Soluciones Digitales B2B para Educación
            </div>
            <h1 className="hero-title">
              Transformamos la <span className="highlight">Gestión Digital</span> de tu Institución Educativa
            </h1>
            <p className="hero-subtitle">
              Plataformas LMS, CRM inteligente y automatización comercial para universidades, 
              institutos profesionales, centros de capacitación y programas de educación continua. 
              Soluciones completas que potencian tu operación educativa y comercial.
            </p>
            
            <div className="hero-features">
              <div className="feature-item">
                <Shield className="feature-icon" />
                <span>Plataformas LMS Administradas</span>
              </div>
              <a href="/crm-canales-digitales" className="feature-item feature-link">
                <div className="feature-icon-group">
                  <MessageCircle className="feature-icon feature-icon-wa" />
                  <Share2 className="feature-icon feature-icon-ig" />
                </div>
                <span>Canales Digitales y CRM</span>
              </a>
              <div className="feature-item">
                <Award className="feature-icon" />
                <span>Soporte Especializado 24/7</span>
              </div>
            </div>

            <div className="hero-buttons">
              <a href="#servicios" className="btn btn-primary">
                Explorar Soluciones
              </a>
              <a href="#contacto" className="btn btn-secondary">
                Agendar Asesoría
              </a>
            </div>
          </div>
          
          <div className="hero-image">
            <div className="hero-illustration">
              <div className="moodle-mockup">
                <div className="mockup-header">
                  <div className="mockup-dots">
                    <span></span>
                    <span></span>
                    <span></span>
                  </div>
                  <div className="mockup-title">Plataforma Educativa</div>
                </div>
                <div className="mockup-content">
                  <div className="mockup-sidebar">
                    <div className="sidebar-item"></div>
                    <div className="sidebar-item"></div>
                    <div className="sidebar-item"></div>
                  </div>
                  <div className="mockup-main">
                    <div className="content-block"></div>
                    <div className="content-block"></div>
                    <div className="content-block small"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;